/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const paragraph_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M16.5 5.058C16.102 3.595 14.469 2.5 12.515 2.5c-2.252 0-4.078 1.455-4.078 3.25 0 1.657 1.557 3.025 3.568 3.225l.32.042M7.5 18.902c.379 1.482 2.024 2.598 3.996 2.598 2.252 0 4.077-1.455 4.077-3.25 0-1.657-1.556-3.025-3.568-3.225l-.32-.041m0 0c2.24.23 4.2-.918 4.376-2.566.176-1.648-1.496-3.17-3.736-3.401m-.64 5.967c-2.239-.231-3.912-1.754-3.735-3.402.177-1.648 2.135-2.796 4.375-2.565"
    />
  </svg>
)
export default paragraph_medium
